import React from 'react';
import { Link } from 'react-router-dom';
import { Navbar, Container, Nav } from 'react-bootstrap';

const NavBarAnon = () => {
  return (
    <Navbar bg="dark" variant="dark" style={{fontFamily:"Poppins"}}>
      <Container>
        <Link to="/" className="navbar-brand">
          NNNChristianBale🦇
        </Link>
        <Nav className="me-auto">
          <Nav.Link as={Link} to="/">
            Sign Up
          </Nav.Link>
          <Nav.Link as={Link} to="/signin">
            Sign In
          </Nav.Link>
        </Nav>
      </Container>
    </Navbar>
  );
};

export default NavBarAnon;
